import { useMutation, useQuery } from '@tanstack/react-query';

import Request from '@/apis/config';
import { IParamsFilter, IResponseApi, IResponseUserList, ListTreeResponse, TreeViewEnum } from '@/interfaces';
import { MUTATIONS_KEY } from '@/interfaces/enum';

type ITransPointContent = {
  agentId: string;
  agentName: string;
  targetAgent: string;
  targetAgentName: string;
  transId: string;
  type: string;
  processingAmount: string;
  previousAmount: string;
  currentAmount: string;
  note: string;
  processDate: string;
  gameTransId: string;
  subType: string;
};
const URL_TRANS_POINT = '/trans-service/transactions/point/list';
export const useTransactionPointMutation = () => {
  return useMutation({
    mutationFn: async (params: IParamsFilter) => {
      const res = await Request.post<IResponseUserList<ITransPointContent>>(URL_TRANS_POINT, params);
      return res;
    },
    mutationKey: [MUTATIONS_KEY.POINT_CASH_HISTORY],
    cacheTime: 0,
  });
};
const URL_PREMIUM_FEE = '/trans-service/transactions/point/premium-fee';
export const usePremiumFeeMutation = () => {
  return useMutation({
    mutationFn: async (params: IParamsFilter) => {
      const res = await Request.post<any>(URL_PREMIUM_FEE, params);
      return res;
    },
    mutationKey: [MUTATIONS_KEY.PREMIUM_FEE],
  });
};

const URL_LIST_TREE_AGENTS = '/auth-service/agents/tree/by-role';
export const useListTreeAgents = () => {
  return useQuery<ListTreeResponse, IResponseApi>({
    queryKey: [TreeViewEnum.LIST_TREE_DATA],
    queryFn: async () => {
      const { data } = await Request.get<ListTreeResponse>(URL_LIST_TREE_AGENTS);
      return data;
    },
  });
};
